module.exports = __webpack_public_path__ + "static/media/why_we_love_product.10f3de34.png";